// extracted by mini-css-extract-plugin
export default {"heroImage":"Landing_heroImage__C-lvb"};